import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Radium from 'higher-order-components/configured-radium/'

class ImageSelector extends Component {
  handleChange = (option, index) => {
    if (this.props.onChange) this.props.onChange(option)
  }
  render() {
    let width = ['55%', '45%']
    if (this.props.options.length === 3) width = ['30%', '40%', '30%']
    return (
      <div style={styles.base} data-test="image-selector">
        {this.props.options.map((option, index) => (
          <div
            style={[
              styles.wrapper,
              { width: width[index] || 'auto' },
              this.props.active === index ? { opacity: 1 } : { opacity: 0.5 }
            ]}
            key={index}>
            <img
              src={option.imageSrc}
              onClick={this.handleChange.bind(this, option, index)}
              style={styles.img} />
          </div>
        ))}
      </div>
    )
  }
}

const styles = {
  base: {
    display: 'flex',
    height: '100%',
    alignItems: 'flex-start',
    padding: '0px 30px'
  },
  wrapper: {
    backgroundSize: 'contain',
    backgroundPosition: 'center top',
    transition: '.5s',
    maxHeight: '100%',
    cursor: 'pointer'
  },
  img: {
    width: '100%',
    height: 'auto'
  }
}

export default Radium(ImageSelector)



// WEBPACK FOOTER //
// ./src/containers/image-selector/index.jsx